<template>
    <div class="view view--users">
        <users-list v-bind:show-filters="{ 'search': true }"
                        v-bind:show-paging="true"
                        v-bind:show-sort="true"
        />
    </div>
</template>

<script>
    import usersList from '../../components/UsersList.vue';

    export default {
        components: {
            usersList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/users/Index.vue